// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../node_modules/rescript/lib/es6/array.js";
import * as Js_string from "../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Caml_array from "../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Config$PorterinUtils from "../configs/Config.mjs";
import * as JsBindings$PorterinUtils from "../bindings/common/JsBindings.mjs";
import * as OptionTypeUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/OptionTypeUtils.mjs";
import * as CookieConstants$PorterinUtils from "../constants/CookieConstants.mjs";

var setCookie = (function (cookie) {
  document.cookie=cookie
 });

function getCookies(param) {
  var cookies = JsBindings$PorterinUtils.isBrowser(undefined) ? document.cookie : "";
  var cookiesLength = cookies.length;
  var cookieList = cookiesLength !== 0 ? $$Array.to_list(Js_string.split(";", Js_string.replaceByRe(/ /g, "", cookies))) : /* [] */0;
  return List.map((function (cookie) {
                var cookie$1 = Js_string.splitByRe(/=(.+)/g, cookie);
                var match = cookie$1.length;
                if (match === 0 || match === 1) {
                  return {
                          key: OptionTypeUtils$Catalyst.getEmptyStringFrmOptionalType(Caml_array.get(cookie$1, 0)),
                          value: ""
                        };
                } else {
                  return {
                          key: OptionTypeUtils$Catalyst.getEmptyStringFrmOptionalType(Caml_array.get(cookie$1, 0)),
                          value: OptionTypeUtils$Catalyst.getEmptyStringFrmOptionalType(Caml_array.get(cookie$1, 1))
                        };
                }
              }), cookieList);
}

function getCookie(cookieName) {
  var cookies = getCookies(undefined);
  var cookie = List.exists((function (a) {
          return a.key === cookieName;
        }), cookies) ? List.find((function (a) {
            return a.key === cookieName;
          }), cookies) : undefined;
  if (cookie !== undefined) {
    return cookie.value;
  } else {
    return "";
  }
}

function setCookieWithExpiration(key, value, daysToExpire) {
  var expiryTime = Math.imul(Math.imul(Math.imul(Math.imul(daysToExpire, 24), 60), 60), 1000) + Date.now();
  var expires = "expires=" + new Date(expiryTime).toUTCString();
  setCookie(key + "=" + value + ";" + expires + ";path=/");
}

function getAuthCookies(param) {
  var web_tracking_id = getCookie(CookieConstants$PorterinUtils.web_tracking_id);
  var auth_token = getCookie(CookieConstants$PorterinUtils.auth_token);
  var mobile = getCookie(CookieConstants$PorterinUtils.mobile);
  return [
          web_tracking_id,
          auth_token,
          mobile
        ];
}

function webTrackingIdSafely(param) {
  var webTrackingId = getCookie("delivery_ck");
  if (webTrackingId === "") {
    return getCookie("visitor_id");
  } else {
    return webTrackingId;
  }
}

export {
  setCookie ,
  getCookies ,
  getCookie ,
  setCookieWithExpiration ,
  getAuthCookies ,
  webTrackingIdSafely ,
}
/* Config-PorterinUtils Not a pure module */
